export const COLLEGE_BOARD_ISSUE_GROUPS = [
  {
    title: "Administrative",
    issues: [
      {
        category: "Reasonable Accommodation Not Applied",
        irregularity:
          "Reasonable accommodation was requested during registration but does not appear enabled on the platform.",
        action:
          "Cancel test. Select category 'Other' and document as: 'Reasonable accommodation not applied – requested during registration'.",
      },
      {
        category: "Absence",
        irregularity: "Student does not physically report to the assigned room.",
        action: "Cancel test. Select category 'Absence'.",
      },
      {
        category: "Voluntary Cancellation – Personal",
        irregularity: "Student decides not to continue taking the test.",
        action:
          "Cancel test. Select category 'Other' and document as: 'Voluntary cancellation – Personal'.",
      },
      {
        category: "Voluntary Cancellation – Health",
        irregularity: "Student cannot continue due to a health condition.",
        action:
          "Cancel test. Select category 'Other' and document as: 'Voluntary cancellation – Health'.",
      },
      {
        category: "Inappropriate Conduct",
        irregularity:
          "Conduct compromising test security or validity (cell phone use, copying, photography, impersonation, unauthorized exit from digital environment, disruptive behavior, etc.).",
        action:
          "Cancel test. Select category 'Other' and document as: 'Inappropriate conduct – [brief description]'.",
      },
      {
        category: "Incorrect Test Configuration",
        irregularity:
          "Assigned test or modality does not match student's official registration.",
        action:
          "Cancel test. Select category 'Other' and document as: 'Incorrect test configuration'.",
      },
      {
        category: "Incorrect Identification",
        irregularity:
          "Student fails to present valid ID or information does not match system records.",
        action:
          "Cancel test. Select category 'Other' and document as: 'Incorrect identification'.",
      },
      {
        category: "Content Irregularity",
        irregularity: "Student alleges an error in an exercise or test content.",
        action:
          "Do NOT cancel test. Allow student to continue. Report section and question number to center director to include in center's irregularity report.",
      },
    ],
  },
  {
    title: "Technical",
    issues: [
      {
        category: "Power Failure",
        irregularity:
          "Power outage preventing test administration from continuing.",
        action:
          "If outage reaches 15 minutes and service is not restored, cancel test. Select category 'Other' and document as: 'Power failure'.",
      },
      {
        category: "Internet Failure",
        irregularity: "Connection is lost during test administration.",
        action:
          "If disconnection reaches 15 minutes and connection is not restored, cancel test. Select category 'Other' and document as: 'Internet failure – browser'.",
      },
      {
        category: "Generic System Interruption",
        irregularity:
          "Platform prevents continuing or submitting answers due to general College Board system issues.",
        action:
          "Notify center director immediately for escalation to College Board help desk. If situation persists for 15 minutes without resolution, cancel test. Select category 'Other' and document as: 'System interruption – College Board'.",
      },
      {
        category: "Individual Technical Issue – Student Device",
        irregularity:
          "Device failure attributable to student equipment or institution technology infrastructure.",
        action:
          "Attempt immediate restart. If problem persists for 15 minutes without resolution, cancel test. Select category 'Other' and document as: 'Equipment failure – institution/student'.",
      },
      {
        category: "Proctor Technical Issue",
        irregularity:
          "Proctor loses connection with students, or proctor device fails due to equipment or internet infrastructure.",
        action:
          "Cancel test. Select category 'Other' and document as: 'Technical issue – proctor disconnected'.",
      },
      {
        category: "Individual Technical Issue – Audio",
        irregularity:
          "Device does not play audio correctly during ELASH administration.",
        action:
          "Verify device volume is active and adjust sound settings from Secure Client home screen. If problem persists for 15 minutes without resolution, cancel test. Select category 'Other' and document as: 'Audio failure on device'.",
      },
    ],
  },
  {
    title: "Remote Warnings",
    issues: [
      {
        category: "Face Not Detected",
        irregularity: "Face not detected or partially visible on camera.",
        action:
          "Issue warning to student and document. If repeated, cancel test. Select category 'Other' and document as: 'Face not detected – [Brief description]'.",
      },
      {
        category: "Microphone Off",
        irregularity: "Student's microphone is turned off.",
        action:
          "Issue warning to student and document. If repeated, cancel test. Select category 'Other' and document as: 'Microphone off – [Brief description]'.",
      },
      {
        category: "Camera Off",
        irregularity: "One of student's cameras is turned off.",
        action:
          "Issue warning to student and document. If repeated, cancel test. Select category 'Other' and document as: 'Camera off – [Brief description]'.",
      },
      {
        category: "Noise Detected",
        irregularity: "Proctor detects background noise in student's environment.",
        action:
          "Issue warning to student and document. If repeated, cancel test. Select category 'Other' and document as: 'Noise detected – [Brief description]'.",
      },
      {
        category: "Reading Aloud",
        irregularity: "Student reads test questions out loud.",
        action:
          "Issue warning to student and document. If repeated, cancel test. Select category 'Other' and document as: 'Reading aloud – [Brief description]'.",
      },
      {
        category: "Inadequate Lighting",
        irregularity: "Student's room does not have sufficient lighting.",
        action:
          "Issue warning to student and document. If repeated, cancel test. Select category 'Other' and document as: 'No lighting – [Brief description]'.",
      },
    ],
  },
  {
    title: "Remote Cancellations",
    issues: [
      {
        category: "Identity Verification Failed",
        irregularity: "Cannot verify identity or confirm student's face.",
        action:
          "Issue prohibited conduct cancellation notice to student and proceed to cancel test. Select category 'Other' and document as: 'Invalid identity – [brief description]'.",
      },
      {
        category: "Out-of-Focus Eye Movement",
        irregularity:
          "Repeatedly looking down/up or fixing gaze on screen corners.",
        action:
          "Issue prohibited conduct cancellation notice to student and proceed to cancel test. Select category 'Other' and document as: 'Eye movement – [brief description]'.",
      },
      {
        category: "Extracted Text",
        irregularity: "Action detected to extract text (copy and paste) in exam.",
        action:
          "Issue prohibited conduct cancellation notice to student and proceed to cancel test. Select category 'Other' and document as: 'Text extracted – [brief description]'.",
      },
      {
        category: "Browser Screen Switch",
        irregularity: "Student switches away from authorized exam tab.",
        action:
          "Issue prohibited conduct cancellation notice to student and proceed to cancel test. Select category 'Other' and document as: 'Screen switch – [brief description]'.",
      },
      {
        category: "Prohibited Object",
        irregularity: "Proctor detects a book, unauthorized object, or device.",
        action:
          "Issue prohibited conduct cancellation notice to student and proceed to cancel test. Select category 'Other' and document as: 'Prohibited object – [brief description]'.",
      },
      {
        category: "Multiple People Detected",
        irregularity:
          "System detects more than one person in student's environment.",
        action:
          "Issue prohibited conduct cancellation notice to student and proceed to cancel test. Select category 'Other' and document as: 'Multiple people – [brief description]'.",
      },
      {
        category: "Mobile Device Detected",
        irregularity:
          "System detects an object similar to an additional mobile device.",
        action:
          "Issue prohibited conduct cancellation notice to student and proceed to cancel test. Select category 'Other' and document as: 'Cell phone – [brief description]'.",
      },
    ],
  },
];

export function formatCollegeBoardIssueLine(category) {
  return `${String(category ?? "")
    .trim()
    .toUpperCase()}: `;
}

export function appendCollegeBoardIssueToNotes(notes, category) {
  const line = formatCollegeBoardIssueLine(category);
  const current = String(notes ?? "");
  if (!current.trim()) return line;
  const separator = current.endsWith("\n") ? "" : "\n";
  return `${current}${separator}${line}`;
}
